import { EditorState } from 'draft-js';
import isUrl from 'is-url';
import prependHttp from 'prepend-http';
import { getContentStateWithAppliedEntity, createEmptySelectionState } from 'Shared/utils/draftJsHelpers';

import AddPluginLink from '../components/AddPluginLink/AddPluginLink';

const ADD_LINK_ENTITY_TYPE = 'LINK';

const addlinkStrategy = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === ADD_LINK_ENTITY_TYPE;
  }, callback);
};

const addLinkPlugin = {
  decorators: [
    {
      strategy: addlinkStrategy,
      component: AddPluginLink,
    },
  ],
};

function formatUrl(url) {
  if (isUrl(url)) return url;
  return prependHttp(url.split(' ')[0]);
}

function applyLink({ editorState, url }) {
  const contentState = editorState.getCurrentContent();
  const selectionState = editorState.getSelection();
  const anchorKey = selectionState.getAnchorKey();
  const start = selectionState.getStartOffset();
  const end = selectionState.getEndOffset();

  const selectionToAddLink = createEmptySelectionState(anchorKey, start, end);

  const contentStateWithAddedLink = getContentStateWithAppliedEntity(
    contentState,
    selectionToAddLink,
    ADD_LINK_ENTITY_TYPE,
    { href: formatUrl(url) }
  );

  return EditorState.push(editorState, contentStateWithAddedLink);
}

export { applyLink, addLinkPlugin };
